var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusTrigger = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C5.60819 0.000446106 6.10112 0.493373 6.10156 1.10156V3.89746H8.89746L8.89648 5L8.89746 6.10254H6.10156V8.89844C6.10112 9.50663 5.60819 9.99955 5 10C4.39118 10 3.89653 9.50627 3.89648 8.89746V6.10254H1.10156C0.492718 6.10254 -0.000976562 5.60884 -0.000976562 5C-0.000976562 4.39116 0.492718 3.89746 1.10156 3.89746H3.89648V1.10254C3.89653 0.493734 4.39118 0 5 0ZM8.89746 3.89746C9.506 3.89783 10 4.39138 10 5C10 5.60862 9.506 6.10217 8.89746 6.10254V3.89746Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusTrigger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlusTrigger.2ba246b2fcd6201cf27a6de29b0277c2.svg";